import { useEffect, useRef } from "react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    const run = async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        let dest = "/dashboard";
        try {
          const next = localStorage.getItem("controlly_next");
          if (next && next.startsWith("/") && !next.startsWith("//")) dest = next;
          localStorage.removeItem("controlly_next");
        } catch { /* ignore */ }
        window.location.replace(dest);
      } catch (e) {
        const d = e?.response?.data?.detail;
        if (d === "account_suspended" || d === "signup_disabled") {
          try { sessionStorage.setItem("controlly_notice", d); } catch { /* ignore */ }
        }
        window.location.replace("/login");
      }
    };
    if (sessionId) run();
    else window.location.replace("/login");
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-zinc-400 font-mono text-sm animate-pulse">Establishing secure session…</div>
    </div>
  );
}
